(function () {
  // ---- Config --------------------------------------------------------------
  var cfg = (window.__VAT_DISPLAY__) || {};
  if (!cfg.enabled || !cfg.rate || cfg.rate <= 0) return;

  var MULTIPLIER = 100 + Number(cfg.rate || 0);

  // ---- Helpers -------------------------------------------------------------
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, cfg.moneyFormat);
      }
    } catch (e) {}
    var value = (Number(cents || 0) / 100).toFixed(2);
    return "R " + value;
  }

  function toInclusive(cents) {
    return Math.round((Number(cents) * MULTIPLIER) / 100);
  }

  // Robust text -> cents:
  function extractCentsFromText(text) {
    if (!text) return null;
    var digits = String(text).replace(/[^\d]/g, "");
    if (!digits) return null;
    return Number(digits);
  }

  function getPriceCentsFromEl(el) {
    if (!el) return null;

    // Prefer explicit data-price on the node
    var centsAttr = el.getAttribute('data-price');
    if (centsAttr != null && centsAttr !== '') return Number(centsAttr);

    // Or a nearest ancestor that carries it
    var carrier = el.closest('[data-price]');
    if (carrier) {
      var c2 = carrier.getAttribute('data-price');
      if (c2 != null && c2 !== '') return Number(c2);
    }

    // Fallback: parse visible text like "R 4,995.00/ea"
    var text = el.textContent || "";
    return extractCentsFromText(text);
  }

  function updatePriceElement(el) {
    if (!el || el.dataset.vatApplied === "1") return;
    var cents = getPriceCentsFromEl(el);
    if (cents == null) return;

    var incl = toInclusive(cents);
    if (String(el.getAttribute('data-price-incl-vat')) === String(incl)) return;

    el.setAttribute('data-price-incl-vat', incl);
    el.textContent = formatMoney(incl);
    el.dataset.vatApplied = "1";
  }

  // ---- Theme-agnostic blocks already on page -------------------------------
  function updatePriceBlock(root) {
    if (!root) return;

    // common “current/regular” price
    updatePriceElement(
      root.querySelector(
        '.price-item.price-item--regular, .price-current, .product-price__current, .product__price, .product-price'
      )
    );

    // common “compare at”
    updatePriceElement(
      root.querySelector('.price__sale .price-item--compare, .price-item--compare, .price-compare, .product-price__compare')
    );
  }

  function updateCards() {
    document
      .querySelectorAll(
        '.card, .product-card, .grid__item .price, .collection .price, .product-grid .price, .card-information .price, .product-item__price'
      )
      .forEach(updatePriceBlock);
  }

  function updateProductPage() {
    var roots = document.querySelectorAll(
      '.product .price, .product__info-wrapper .price, .product-price, .product__price-wrap, .product-meta .price'
    );
    roots.forEach(updatePriceBlock);
  }

  // ---- Trade theme: Quick Order List ---------------------------------------
  function updateQuickOrderList() {
    // Current per-item price and unit prices
    var unitNodes = document.querySelectorAll(
      '.price-per-item--current.price, .variant-item__price .price,' +
      '.variant-item__details .price'
    );
    unitNodes.forEach(updatePriceElement);

    // Totals cell (right column)
    var totalNodes = document.querySelectorAll('.variant-item__totals .price');
    totalNodes.forEach(updatePriceElement);
  }

  // ---- Cart page -----------------------------------------------------------
  function updateCartPage() {
    // Unit price under product name (handles normal + discounted)
    var unitPriceNodes = document.querySelectorAll(
      '.cart-item__final-price, .cart-item__old-price, .cart-item__details .product-option .price, .cart-item__details .product-option'
    );
    unitPriceNodes.forEach(updatePriceElement);

    // Line totals in the "Total" column (mobile + desktop)
    var lineTotalNodes = document.querySelectorAll(
      '.cart-item__totals .price, .cart-item__totals .cart-item__old-price'
    );
    lineTotalNodes.forEach(updatePriceElement);

    // Estimated total / subtotal in footer
    var subtotalNodes = document.querySelectorAll(
      '.totals__total-value .price, .totals__subtotal-value .price, .cart-subtotal .price'
    );
    subtotalNodes.forEach(updatePriceElement);
  }

  // ---- Orchestration -------------------------------------------------------
  function runAll() {
    updateProductPage();
    updateCards();
    updateQuickOrderList();
    updateCartPage();
  }

  // throttle noisy updates
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      runAll();
    }, 120);
  }

  // first pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll, { once: true });
  } else {
    runAll();
  }

  // common theme events (variants/sections)
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('shopify:section:deselect', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  // observe DOM additions (quick order list & cart re-renders via JS)
  var observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type !== 'childList') continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (
          (n.matches &&
            n.matches(
              '.price, .product, .product-price, .product-item, .product-card, .variant-item__price, .variant-item__totals, .cart-item__totals, .cart-item__details, .totals__total-value'
            )) ||
          (n.querySelector &&
            n.querySelector(
              '.price, .product-price, .variant-item__price, .variant-item__totals, .cart-item__totals, .cart-item__details, .totals__total-value'
            ))
        ) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
